var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyInstoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9946,
    cy: 28.0063,
    r: 28.0063,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.375 26.25V38.3056C40.375 39.1378 39.6367 39.8125 38.726 39.8125H20.5865C19.6758 39.8125 18.9375 39.1378 18.9375 38.3056V26.25",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3987 17.0625H19.4763C19.0935 17.0624 18.7618 17.3114 18.6782 17.6617L17.1875 23.9531C17.1875 25.2217 18.2844 26.25 19.6375 26.25C20.9906 26.25 22.0875 25.2217 22.0875 23.9531C22.0875 25.2217 23.1844 26.25 24.5375 26.25C25.8906 26.25 26.9875 25.2217 26.9875 23.9531C26.9875 25.2217 28.0844 26.25 29.4375 26.25C30.7906 26.25 31.8875 25.2217 31.8875 23.9531C31.8875 25.2217 32.9844 26.25 34.3375 26.25C35.6906 26.25 36.7875 25.2217 36.7875 23.9531C36.7875 25.2217 37.8844 26.25 39.2375 26.25C40.5906 26.25 41.6875 25.2217 41.6875 23.9531L40.1957 17.6617C40.1129 17.3114 39.7814 17.0622 39.3987 17.0625Z",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 33.7548C32.5 32.2679 31.1289 31.0625 29.4375 31.0625C27.7461 31.0625 26.375 32.2679 26.375 33.7548V39.8125H32.5V33.7548Z",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyInstoreIcon);
export default __webpack_public_path__ + "static/media/buy-instore-icon.99663914d6043da40913dff0cdad8065.svg";
export { ForwardRef as ReactComponent };